import {ThemeOptions} from '@mui/material';

export const baseTheme: ThemeOptions = {
    typography: {
        fontFamily: 'Poppins',
        button: {
            textTransform: 'none',
        },
        h1: {
            fontSize: 24,
            fontWeight: 600,
        },
        h4: {
            fontSize: 22,
        },
        h5: {
            fontSize: 19,
        },
    },
    components: {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                },
            },
        },
        MuiCard: {
            defaultProps: {
                elevation: 5,
            },
        },
        MuiButton: {
            variants: [
                {
                    style: {
                        padding: `13px 22px`,
                        borderRadius: 25,
                    },
                    props: {
                        size: 'large',
                    },
                },
                {
                    style: {
                        padding: `9px 16px`,
                    },
                    props: {
                        size: 'medium',
                    },
                },
            ],
        },
    },
};

export default baseTheme;
